module.exports = __webpack_public_path__ + "img/gl.svg";